import React, {  useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dateFormat from "dateformat";
import * as HELPER from "@src/config/helper";
import Pagination from '@src/common/Pagination';
import { useLanguage } from "@src/context/LanguageContext";


type OptionType = {
  value: number;
  label: string;
};

interface LeadTableProps {
  leadList: any[];
  paginationData: any;
  getLeadListing: (params: any) => void;
  selectedFilters: any;
  statusFilterList: any;
  reasonList: any
}

const LeadTable: React.FC<LeadTableProps> = ({
  leadList,
  paginationData,
  getLeadListing,
  selectedFilters,
  statusFilterList,
  reasonList
}) => {
  const [sortCreatedDirection, setSortCreatedDirection] = useState<'asc' | 'desc'>('desc');
  const [sortPolicyDirection, setSortPolicyDirection] = useState<'asc' | 'desc'>('desc');
  const [sortSumDirection, setSortSumDirection] = useState<'asc' | 'desc'>('desc');
  const {translations} = useLanguage();

  const navigate = useNavigate();
  const page = 1;

  const detailPageRedirect = (item: any) => {
      navigate(`/lead-details/${item.hashId}`, {
      state: { reasonList },
    });
  }

  const handleRequestData = (params: any) => {
    let apiParams = {
        ...selectedFilters,
        ...params,
       page_number: params.page_no
    }

    getLeadListing(apiParams)
  }

  const handleSort = (column: string) => {
    if(column === 'lead_created_at') {
      let sortDirection: any = sortCreatedDirection === 'asc' ? 'desc' : 'asc';
      selectedFilters.sortBy = { 
        lead_created_at: sortDirection
      }
      setSortCreatedDirection(sortDirection);
    }

    if(column === 'insurance_starting_date') {
        let sortDirection: any  = sortPolicyDirection === 'asc' ? 'desc' : 'asc';
        selectedFilters.sortBy = { 
          insurance_starting_date: sortDirection
        }
        setSortPolicyDirection(sortDirection);
    }

    if(column === 'total_sum_insured') {
       let sortDirection: any = sortSumDirection === 'asc' ? 'desc' : 'asc';
        selectedFilters.sortBy = { 
          total_fmv_car: sortDirection
        }
        setSortSumDirection(sortDirection);
    }
    handleRequestData({ page_number: 1,page_no:1 });
  };

  const getStatusLabelAndClass = (status: number | string, statusList: OptionType[]) => {
    const statusItem = statusList.find(item => item.value === status);
    let className = '';

    switch (status) {
      case 1:
        className = '';
        break;
      case 4:
        className = 'reconciled-txt';
        break;
      case 5:
        className = 'rejected-txt';
        break;
      default:
        className = '';
    }

    return {
      label: statusItem?.label || '',
      className,
    };
  };

  return (
    <div className='data-table lead-list-table'>
      <table>
        <thead>
          <tr>
            <th>{translations.Insurance?.['INSURANCE_LEAD_ID'] || translations.commonMsg?.loading} </th>
            <th>{translations.Insurance?.['CUSTOMER_NAME'] || translations.commonMsg?.loading} </th>
            <th>{translations.Insurance?.['VEHICLE_DETAIL'] || translations.commonMsg?.loading} </th>
            <th>{translations.Insurance?.['INSURANCE_TYPE'] || translations.commonMsg?.loading} </th>
            <th>{translations.Insurance?.['CREATION_DATE'] || translations.commonMsg?.loading} 
              &nbsp; <i className={`ic-sort-${sortCreatedDirection}`} style={{ cursor: 'pointer' }} onClick={() => handleSort('lead_created_at')}></i>
            </th>
            <th>{translations.Insurance?.['PLOICY_START_DATE'] || translations.commonMsg?.loading} 
              &nbsp; <i className={`ic-sort-${sortPolicyDirection}`} style={{ cursor: 'pointer' }} onClick={() => handleSort('insurance_starting_date')}></i>
            </th>
            <th>{translations.Insurance?.['TOTAL_SUM_INSURED'] || translations.commonMsg?.loading} 
              &nbsp; <i className={`ic-sort-${sortSumDirection}`} style={{ cursor: 'pointer' }} onClick={() => handleSort( 'total_sum_insured')}></i>
            </th>
            <th>{translations.Insurance?.['STATUS'] || translations.commonMsg?.loading} </th>
            <th>{translations.Insurance?.['ACTION'] || translations.commonMsg?.loading} </th>
          </tr>
        </thead>
        <tbody>

            {
              leadList.length
                  ?
              leadList.map((list: any, key: number) =>
                <tr key={key}>
                  <td>{list.insurance_id || ""} </td>
                  <td>
                    <span>{list?.customer_name || ''}</span>
                    {/* <span>{list?.customer_mobile || ''}</span> */}
                  </td>
                  <td>{list.make_name || ""} {list.model_name || ""}</td>
                  <td>{list.insurance_type || ""} </td>
                  <td>{dateFormat(list.created_date, 'd mmm yyyy')}</td>
                  <td>
                    {
                      list.insurance_starting_date === null || list.insurance_starting_date  === "" ? '-' :
                      dateFormat(list.insurance_starting_date, 'd mmm yyyy') 
                    }
                  </td>
                  <td>{
                    list?.total_fmv_car
                    ?
                    HELPER.addCurrencyFormatting(list?.total_fmv_car) : 0
                  } </td>
                  
                  {/* <td><span className='reconciled-txt'>{list.payment_status || ""}</span></td> */}
                  <td>
                    {(() => {
                      const { label, className } = getStatusLabelAndClass(list.action_status, statusFilterList);
                      return <span className={className}>{label}</span>;
                    })()}
                  </td>
                  <td>
                    <ul className="action-btn">
                      <li className="" title="View Detail" onClick={() => detailPageRedirect(list)}>
                            <i className="ic-remove_red_eyevisibility"></i>
                        </li>
                    </ul>
                  </td>
                </tr>
                )

              :
              <tr><td colSpan={9} style={{ textAlign: 'center' }}>No data found</td></tr>

            }

        </tbody>
      </table>

      {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
          page,
          loading: false,
          totalLengthWithoutPagination: paginationData['total'],
          paginationData,
          filteredData: selectedFilters
        }}
        sendRequestDataToParent={handleRequestData} />}

    </div>
  )
}

export default LeadTable;